<template>
  <StackLayout class="wrapper">
    <AgCard modal :caption="caption">
      <StackLayout class="card-content">
        <Label textWrap :text="text" />
        <AgButton v-if="state === 'success' || state === 'fail'" text="Schließen" @tap="close" @click="close" />
      </StackLayout>
      <StackLayout v-if="state === 'initial' || state === 'loading'">
        <StackLayout class="card-content details">
          <AgCollapsible label="Was wird übermittelt?">
            <GridLayout columns="30, *" rows="auto, auto, auto, auto, auto, auto">
              <AgIcon col="0" row="0" type="circle" size="8" verticalAlignment="top" />
              <Label col="1" row="0" textWrap text="Informationen zum aufgetretenen Fehler" />
              <AgIcon col="0" row="1" type="circle" size="8" verticalAlignment="top" />
              <Label col="1" row="1" textWrap text="Plattform und Version Ihres Geräts" />
              <AgIcon col="0" row="3" type="circle" size="8" verticalAlignment="top" />
              <Label col="1" row="3" textWrap text="Informationen zu Ihrem Kundenkonto" />
            </GridLayout>
          </AgCollapsible>
        </StackLayout>
        <StackLayout class="card-content">
          <AgButton :loading="state === 'loading'" text="Problem melden" @tap="send" @click="send" />
          <AgButton outlined text="Abbrechen" @tap="close" @click="close" />
        </StackLayout>
      </StackLayout>
    </AgCard>
  </StackLayout>
</template>

<script>

import { store } from '@/store'
import env from '@/helpers/env'
import DiagnosticsService from '@/services/diagnostics'

export default {
  props: {
    type: {
      type: String,
      default: '[type]'
    },
    message: {
      type: String,
      default: '[message]'
    },
    details: {
      type: [Object, Error]
    }
  },
  data () {
    return {
      state: 'initial'
    }
  },
  computed: {
    caption () {
      switch (this.state) {
        case 'success':
          return 'Problem gemeldet'

        case 'fail':
          return 'Problem melden nicht möglich'
      }

      if (env.mode === 'development') {
        return this.type + ': ' + this.message
      } else {
        return 'Hoppla! Das sollte nicht passieren!'
      }
    },
    text () {
      switch (this.state) {
        case 'success':
          return 'Vielen Dank für das Melden des Problems. Wir werden uns zeitnah um eine Lösung kümmern.'

        case 'fail':
          return 'Das Problem kann zur Zeit leider nicht gemeldet werden. Bitte wenden Sie sich telefonisch oder per E-Mail an unseren Kundendienst.'
      }

      if (env.mode === 'development') {
        return JSON.stringify(this.details)
      } else {
        return 'Wir entschuldigen uns für die Unannehmlichkeiten. Damit wir den Fehler möglichst schnell beheben können, klicken Sie bitte auf den Button „Problem melden“.'
      }
    }
  },
  methods: {
    send () {
      this.state = 'loading'

      if (this.type === 'Client-Error') {
        DiagnosticsService.reportError(this.type, this.message, this.details, env.system, store.state.recentRoute, store.state.user, env.appVersion).then(() => {
          this.state = 'success'
        }).catch(() => {
          this.state = 'fail'
        })
      } else {
        this.state = 'success'
      }
    },
    close () {
      this.$emit('done')
    }
  }
}

</script>

<style lang="scss" scoped>

.ns-ios,
.ns-android {
  .wrapper .details .icon {
    margin-top: 7;
  }
}

html {
  .wrapper .details .icon {
    margin-top: 7px;
  }
}

</style>